import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';


import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import bvlogo from '../assets/bvlogo.png';
import circle from '../assets/circle.svg';
import navlogogif from '../assets/navlogo.gif';
import navlogo from '../assets/navlogo.png';
import navlogopurple from '../assets/navlogopurple.png';
import navlogoblue from '../assets/navlogoblue.png';

import wordpress from '../assets/wordpress.png';
import vscode from '../assets/vscode.png';
import adobephotoshop from '../assets/adobephotoshop.png';
import php from '../assets/php.png';
import reactskill from '../assets/reactskill.png';

export default {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  node,
  python,
  react,
  redux,
  sass,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  navlogo,
  navlogopurple,
  navlogoblue,
  navlogogif,
  bvlogo,
  adobephotoshop,
  wordpress,
  vscode,
  php,
  reactskill,
};